import { Question } from '@verzekeringapp-mono/shared/src/models/value_meter_question'
import { getNormalizedRulesForQuestion } from '@verzekeringapp-mono/shared/src/utils/laravel_normalize_rules'
import { laravelValidate } from '@verzekeringapp-mono/shared/src/utils/laravel_validation'
import { useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import TextInput from '~/components/TextInput'

const CalculationField = ({
  question,
  control,
  setValue,
  calculation
}: {
  question: Question
  control: ReturnType<typeof useFormContext>['control']
  setValue: ReturnType<typeof useFormContext>['setValue']
  calculation: (q: Question) => number
}) => {
  const result = calculation(question)

  useEffect(() => {
    setValue(question.name, result, {
      shouldValidate: true,
      shouldDirty: true
    })
  }, [result, question.name, setValue])

  return (
    <Controller
      name={question.name}
      control={control}
      defaultValue={result}
      rules={{
        validate: laravelValidate(getNormalizedRulesForQuestion(question))
      }}
      render={({ field, fieldState }) => (
        <TextInput
          {...field}
          disabled
          type='number'
          value={result.toString()}
          showValidationIcon={false}
          shouldValidate={true}
          placeholder={question.label}
          icon='euro'
          isValid={!fieldState.error}
          className='mt-0 mb-0'
        />
      )}
    />
  )
}

export default CalculationField
